/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightUnit = exports.TaxableAddressType = exports.SuggestedFix = exports.SubscriptionFrequency = exports.Severity = exports.RuleType = exports.RateType = exports.PickupMethod = exports.PaymentOptionType = exports.NameInOther = exports.NameInLineItem = exports.MediaItemType = exports.ManualCalculationReason = exports.LineItemType = exports.JurisdictionType = exports.ItemTypeItemType = exports.ItemAvailabilityStatus = exports.IdentityType = exports.GetCheckoutPaymentSettingsResponsePaymentOption = exports.FileType = exports.FallbackReason = exports.DiscountDiscountType = exports.DescriptionLineType = exports.CommonVatType = exports.ChargeType = exports.ChannelInfoChannelType = exports.AppliedDiscountDiscountType = exports.ApiVatType = exports.ApiChannelType = exports.AdditionalFeeSource = void 0;
var AdditionalFeeSource;
(function (AdditionalFeeSource) {
    AdditionalFeeSource["UNKNOWN_ADDITIONAL_FEE_SOURCE"] = "UNKNOWN_ADDITIONAL_FEE_SOURCE";
    AdditionalFeeSource["SERVICE_PLUGIN"] = "SERVICE_PLUGIN";
    AdditionalFeeSource["ITEM"] = "ITEM";
    AdditionalFeeSource["MANUAL"] = "MANUAL";
    AdditionalFeeSource["SHIPPING"] = "SHIPPING";
})(AdditionalFeeSource = exports.AdditionalFeeSource || (exports.AdditionalFeeSource = {}));
var ApiChannelType;
(function (ApiChannelType) {
    ApiChannelType["UNSPECIFIED"] = "UNSPECIFIED";
    ApiChannelType["WEB"] = "WEB";
    ApiChannelType["POS"] = "POS";
    ApiChannelType["EBAY"] = "EBAY";
    ApiChannelType["AMAZON"] = "AMAZON";
    ApiChannelType["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    ApiChannelType["WIX_APP_STORE"] = "WIX_APP_STORE";
    ApiChannelType["WIX_INVOICES"] = "WIX_INVOICES";
    ApiChannelType["BACKOFFICE_MERCHANT"] = "BACKOFFICE_MERCHANT";
    ApiChannelType["WISH"] = "WISH";
    ApiChannelType["CLASS_PASS"] = "CLASS_PASS";
    ApiChannelType["GLOBAL_E"] = "GLOBAL_E";
    ApiChannelType["FACEBOOK"] = "FACEBOOK";
    ApiChannelType["ETSY"] = "ETSY";
    ApiChannelType["TIKTOK"] = "TIKTOK";
    ApiChannelType["FAIRE_COM"] = "FAIRE_COM";
    ApiChannelType["PAYPAL_AGENTIC_CHECKOUT"] = "PAYPAL_AGENTIC_CHECKOUT";
})(ApiChannelType = exports.ApiChannelType || (exports.ApiChannelType = {}));
var ApiVatType;
(function (ApiVatType) {
    ApiVatType["UNSPECIFIED_TAX_TYPE"] = "UNSPECIFIED_TAX_TYPE";
    ApiVatType["CPF"] = "CPF";
    ApiVatType["CNPJ"] = "CNPJ";
})(ApiVatType = exports.ApiVatType || (exports.ApiVatType = {}));
var AppliedDiscountDiscountType;
(function (AppliedDiscountDiscountType) {
    AppliedDiscountDiscountType["GLOBAL"] = "GLOBAL";
    AppliedDiscountDiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
    AppliedDiscountDiscountType["SHIPPING"] = "SHIPPING";
})(AppliedDiscountDiscountType = exports.AppliedDiscountDiscountType || (exports.AppliedDiscountDiscountType = {}));
var ChannelInfoChannelType;
(function (ChannelInfoChannelType) {
    ChannelInfoChannelType["UNSPECIFIED"] = "UNSPECIFIED";
    ChannelInfoChannelType["WEB"] = "WEB";
    ChannelInfoChannelType["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    ChannelInfoChannelType["WIX_APP_STORE"] = "WIX_APP_STORE";
})(ChannelInfoChannelType = exports.ChannelInfoChannelType || (exports.ChannelInfoChannelType = {}));
var ChargeType;
(function (ChargeType) {
    ChargeType["HANDLING_FEE"] = "HANDLING_FEE";
    ChargeType["INSURANCE"] = "INSURANCE";
})(ChargeType = exports.ChargeType || (exports.ChargeType = {}));
var CommonVatType;
(function (CommonVatType) {
    CommonVatType["UNSPECIFIED"] = "UNSPECIFIED";
    CommonVatType["CPF"] = "CPF";
    CommonVatType["CNPJ"] = "CNPJ";
})(CommonVatType = exports.CommonVatType || (exports.CommonVatType = {}));
var DescriptionLineType;
(function (DescriptionLineType) {
    DescriptionLineType["UNRECOGNISED"] = "UNRECOGNISED";
    DescriptionLineType["PLAIN_TEXT"] = "PLAIN_TEXT";
    DescriptionLineType["COLOR"] = "COLOR";
})(DescriptionLineType = exports.DescriptionLineType || (exports.DescriptionLineType = {}));
var DiscountDiscountType;
(function (DiscountDiscountType) {
    DiscountDiscountType["UNDEFINED"] = "UNDEFINED";
    DiscountDiscountType["AMOUNT"] = "AMOUNT";
    DiscountDiscountType["PERCENT"] = "PERCENT";
})(DiscountDiscountType = exports.DiscountDiscountType || (exports.DiscountDiscountType = {}));
var FallbackReason;
(function (FallbackReason) {
    FallbackReason["AUTO_TAX_FAILED"] = "AUTO_TAX_FAILED";
    FallbackReason["AUTO_TAX_DEACTIVATED"] = "AUTO_TAX_DEACTIVATED";
})(FallbackReason = exports.FallbackReason || (exports.FallbackReason = {}));
var FileType;
(function (FileType) {
    FileType["UNSPECIFIED"] = "UNSPECIFIED";
    FileType["SECURE_PICTURE"] = "SECURE_PICTURE";
    FileType["SECURE_VIDEO"] = "SECURE_VIDEO";
    FileType["SECURE_DOCUMENT"] = "SECURE_DOCUMENT";
    FileType["SECURE_MUSIC"] = "SECURE_MUSIC";
    FileType["SECURE_ARCHIVE"] = "SECURE_ARCHIVE";
})(FileType = exports.FileType || (exports.FileType = {}));
var GetCheckoutPaymentSettingsResponsePaymentOption;
(function (GetCheckoutPaymentSettingsResponsePaymentOption) {
    GetCheckoutPaymentSettingsResponsePaymentOption["UNKNOWN_PAYMENT_OPTION"] = "UNKNOWN_PAYMENT_OPTION";
    GetCheckoutPaymentSettingsResponsePaymentOption["MANUAL"] = "MANUAL";
})(GetCheckoutPaymentSettingsResponsePaymentOption = exports.GetCheckoutPaymentSettingsResponsePaymentOption || (exports.GetCheckoutPaymentSettingsResponsePaymentOption = {}));
var IdentityType;
(function (IdentityType) {
    IdentityType["UNSPECIFIED_IDENTITY_TYPE"] = "UNSPECIFIED_IDENTITY_TYPE";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["CONTACT"] = "CONTACT";
})(IdentityType = exports.IdentityType || (exports.IdentityType = {}));
var ItemAvailabilityStatus;
(function (ItemAvailabilityStatus) {
    ItemAvailabilityStatus["AVAILABLE"] = "AVAILABLE";
    ItemAvailabilityStatus["NOT_FOUND"] = "NOT_FOUND";
    ItemAvailabilityStatus["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    ItemAvailabilityStatus["PARTIALLY_AVAILABLE"] = "PARTIALLY_AVAILABLE";
})(ItemAvailabilityStatus = exports.ItemAvailabilityStatus || (exports.ItemAvailabilityStatus = {}));
var ItemTypeItemType;
(function (ItemTypeItemType) {
    ItemTypeItemType["UNRECOGNISED"] = "UNRECOGNISED";
    ItemTypeItemType["PHYSICAL"] = "PHYSICAL";
    ItemTypeItemType["DIGITAL"] = "DIGITAL";
    ItemTypeItemType["GIFT_CARD"] = "GIFT_CARD";
    ItemTypeItemType["SERVICE"] = "SERVICE";
})(ItemTypeItemType = exports.ItemTypeItemType || (exports.ItemTypeItemType = {}));
var JurisdictionType;
(function (JurisdictionType) {
    JurisdictionType["UNDEFINED"] = "UNDEFINED";
    JurisdictionType["COUNTRY"] = "COUNTRY";
    JurisdictionType["STATE"] = "STATE";
    JurisdictionType["COUNTY"] = "COUNTY";
    JurisdictionType["CITY"] = "CITY";
    JurisdictionType["SPECIAL"] = "SPECIAL";
})(JurisdictionType = exports.JurisdictionType || (exports.JurisdictionType = {}));
var LineItemType;
(function (LineItemType) {
    LineItemType["UNSPECIFIED_LINE_ITEM_TYPE"] = "UNSPECIFIED_LINE_ITEM_TYPE";
    LineItemType["PHYSICAL"] = "PHYSICAL";
    LineItemType["DIGITAL"] = "DIGITAL";
    LineItemType["CUSTOM_AMOUNT_ITEM"] = "CUSTOM_AMOUNT_ITEM";
})(LineItemType = exports.LineItemType || (exports.LineItemType = {}));
var ManualCalculationReason;
(function (ManualCalculationReason) {
    ManualCalculationReason["GLOBAL_SETTING_TO_MANUAL"] = "GLOBAL_SETTING_TO_MANUAL";
    ManualCalculationReason["REGION_SETTING_TO_MANUAL"] = "REGION_SETTING_TO_MANUAL";
})(ManualCalculationReason = exports.ManualCalculationReason || (exports.ManualCalculationReason = {}));
var MediaItemType;
(function (MediaItemType) {
    MediaItemType["UNSPECIFIED_MEDIA_TYPE_ITEM"] = "UNSPECIFIED_MEDIA_TYPE_ITEM";
    MediaItemType["IMAGE"] = "IMAGE";
})(MediaItemType = exports.MediaItemType || (exports.MediaItemType = {}));
var NameInLineItem;
(function (NameInLineItem) {
    NameInLineItem["LINE_ITEM_DEFAULT"] = "LINE_ITEM_DEFAULT";
})(NameInLineItem = exports.NameInLineItem || (exports.NameInLineItem = {}));
var NameInOther;
(function (NameInOther) {
    NameInOther["OTHER_DEFAULT"] = "OTHER_DEFAULT";
    NameInOther["DELIVERY"] = "DELIVERY";
})(NameInOther = exports.NameInOther || (exports.NameInOther = {}));
var PaymentOptionType;
(function (PaymentOptionType) {
    PaymentOptionType["FULL_PAYMENT_ONLINE"] = "FULL_PAYMENT_ONLINE";
    PaymentOptionType["FULL_PAYMENT_OFFLINE"] = "FULL_PAYMENT_OFFLINE";
    PaymentOptionType["MEMBERSHIP"] = "MEMBERSHIP";
    PaymentOptionType["DEPOSIT_ONLINE"] = "DEPOSIT_ONLINE";
    PaymentOptionType["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
    PaymentOptionType["MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER"] = "MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER";
})(PaymentOptionType = exports.PaymentOptionType || (exports.PaymentOptionType = {}));
var PickupMethod;
(function (PickupMethod) {
    PickupMethod["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    PickupMethod["STORE_PICKUP"] = "STORE_PICKUP";
    PickupMethod["PICKUP_POINT"] = "PICKUP_POINT";
})(PickupMethod = exports.PickupMethod || (exports.PickupMethod = {}));
var RateType;
(function (RateType) {
    RateType["NO_TAX_COLLECTED"] = "NO_TAX_COLLECTED";
    RateType["MANUAL_RATE"] = "MANUAL_RATE";
    RateType["AUTO_RATE"] = "AUTO_RATE";
    RateType["FALLBACK_RATE"] = "FALLBACK_RATE";
})(RateType = exports.RateType || (exports.RateType = {}));
var RuleType;
(function (RuleType) {
    RuleType["VALIDATION"] = "VALIDATION";
    RuleType["OTHER"] = "OTHER";
    RuleType["MAX"] = "MAX";
    RuleType["MIN"] = "MIN";
    RuleType["MAX_LENGTH"] = "MAX_LENGTH";
    RuleType["MIN_LENGTH"] = "MIN_LENGTH";
    RuleType["MAX_SIZE"] = "MAX_SIZE";
    RuleType["MIN_SIZE"] = "MIN_SIZE";
    RuleType["FORMAT"] = "FORMAT";
    RuleType["DECIMAL_LTE"] = "DECIMAL_LTE";
    RuleType["DECIMAL_GTE"] = "DECIMAL_GTE";
    RuleType["DECIMAL_LT"] = "DECIMAL_LT";
    RuleType["DECIMAL_GT"] = "DECIMAL_GT";
    RuleType["DECIMAL_MAX_SCALE"] = "DECIMAL_MAX_SCALE";
    RuleType["INVALID_ENUM_VALUE"] = "INVALID_ENUM_VALUE";
    RuleType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
    RuleType["FIELD_NOT_ALLOWED"] = "FIELD_NOT_ALLOWED";
    RuleType["ONE_OF_ALIGNMENT"] = "ONE_OF_ALIGNMENT";
})(RuleType = exports.RuleType || (exports.RuleType = {}));
var Severity;
(function (Severity) {
    Severity["WARNING"] = "WARNING";
    Severity["ERROR"] = "ERROR";
})(Severity = exports.Severity || (exports.Severity = {}));
var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency = exports.SubscriptionFrequency || (exports.SubscriptionFrequency = {}));
var SuggestedFix;
(function (SuggestedFix) {
    SuggestedFix["UNKNOWN_SUGGESTED_FIX"] = "UNKNOWN_SUGGESTED_FIX";
    SuggestedFix["REMOVE_LINE_ITEM"] = "REMOVE_LINE_ITEM";
})(SuggestedFix = exports.SuggestedFix || (exports.SuggestedFix = {}));
var TaxableAddressType;
(function (TaxableAddressType) {
    TaxableAddressType["UNKNOWN_TAXABLE_ADDRESS"] = "UNKNOWN_TAXABLE_ADDRESS";
    TaxableAddressType["BUSINESS"] = "BUSINESS";
    TaxableAddressType["BILLING"] = "BILLING";
    TaxableAddressType["SHIPPING"] = "SHIPPING";
})(TaxableAddressType = exports.TaxableAddressType || (exports.TaxableAddressType = {}));
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["UNSPECIFIED_WEIGHT_UNIT"] = "UNSPECIFIED_WEIGHT_UNIT";
    WeightUnit["KG"] = "KG";
    WeightUnit["LB"] = "LB";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
//# sourceMappingURL=types.js.map